import type { TransactionEvent } from '@sentry/core';

// `ignoreResourceSpans` matches ops exactly: every Fetch spec initiator type, plus the `icon` and
// `use` that browsers report for favicons and SVG sprites. The SDK skips fetch and XHR itself.
const RESOURCE_INITIATOR_TYPES = [
   'audio',
   'beacon',
   'body',
   'css',
   'early-hints',
   'embed',
   'font',
   'frame',
   'icon',
   'iframe',
   'image',
   'img',
   'input',
   'link',
   'object',
   'other',
   'ping',
   'script',
   'track',
   'use',
   'video',
];

export const IGNORED_RESOURCE_SPAN_OPS: string[] = RESOURCE_INITIATOR_TYPES.map(
   type => `resource.${type}`
);

type UserAgentBrand = { brand: string; version: string };

// Client hints aren't in TypeScript's DOM lib.
type NavigatorWithClientHints = Navigator & {
   userAgentData?: { brands: UserAgentBrand[] };
};

export function isLikelyBot(nav: NavigatorWithClientHints = navigator): boolean {
   if (nav.webdriver) {
      return true;
   }
   if (/HeadlessChrome|Lighthouse/.test(nav.userAgent)) {
      return true;
   }
   return chromeVersionsDisagree(nav);
}

// A bot that fakes its UA string rarely fakes the client hints to match.
function chromeVersionsDisagree(nav: NavigatorWithClientHints): boolean {
   const uaVersion = /Chrome\/(\d+)/.exec(nav.userAgent)?.[1];
   const hintVersion = nav.userAgentData?.brands?.find(b => b.brand === 'Chromium')?.version;
   return uaVersion !== undefined && hintVersion !== undefined && uaVersion !== hintVersion;
}

export function isUnpaintedPageload(event: TransactionEvent): boolean {
   return (
      event.contexts?.trace?.op === 'pageload' &&
      event.measurements?.fcp === undefined &&
      event.measurements?.lcp === undefined
   );
}
